import Vue from 'vue';
import Vuetify from 'vuetify';
import VueLogger from 'vuejs-logger';
import { sync } from 'vuex-router-sync';

import App from './App';
import components from './components';
import store from './store';
import router from './router';

Vue.use(VueLogger, {
    logLevel: process.env.NODE_ENV !== 'production' ? 'debug' : 'info',
    // optional : defaults to false if not specified
    stringifyArguments: false,
    // optional : defaults to false if not specified
    showLogLevel: true,
});
Vue.use(Vuetify);
Vue.config.productionTip = false;

Object.keys(components).forEach((key) => {
    Vue.component(key, components[key]);
});

// sync the router with the vuex store.
// this registers `store.state.route`
sync(store, router);

// interesting ref on how to init security creds on app reload
// https://stackoverflow.com/questions/42579601/how-to-access-async-store-data-in-vue-router-for-usage-in-beforeenter-hook
store.dispatch('auth/INIT').then(() => {
    // create the app instance.
    // here we inject the router and store to all child components,
    // making them available everywhere as `this.$router` and `this.$store`.
    /* eslint-disable no-new */
    new Vue({
        el: '#app',
        router,
        store,
        render: h => h(App),
    });
});



// WEBPACK FOOTER //
// ./src/main.js